<div class="mat-page">
  <div class="mat-header">
    <div>
      <h1>{{ pageTitleKey | translate }}</h1>
      <p *ngIf="pageSubtitle">{{ pageSubtitle }}</p>
      <p class="mat-org" *ngIf="organizationName">
        {{ 'COMPANY_NAME' | translate }}: {{ organizationName }}
        <span *ngIf="organizationCode">· {{ organizationCode }}</span>
      </p>
    </div>
    <div class="mat-header-actions">
      <button type="button" class="ghost-btn" (click)="goBack()">{{ 'BACK' | translate }}</button>
      <button
        type="button"
        class="primary-btn"
        *ngIf="viewMode && constructionmaterialsId"
        (click)="goToEdit()"
      >
        {{ 'EDIT_MATERIAL' | translate }}
      </button>
    </div>
  </div>

  <form [formGroup]="materialsForm" (ngSubmit)="onSubmit()" class="mat-form">
    <section class="form-section">
      <h2>Identity</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'MATERIAL_NAME' | translate }} <span class="req">*</span></span>
          <input class="form-control" formControlName="name" />
          <span class="field-error" *ngIf="materialsForm.get('name')?.hasError('required') && materialsForm.get('name')?.touched">
            {{ 'REQUIRED' | translate }}
          </span>
        </label>
        <label class="field">
          <span class="field-label">{{ 'CATEGORY' | translate }} <span class="req">*</span></span>
          <input class="form-control" formControlName="category" />
          <span class="field-error" *ngIf="materialsForm.get('category')?.hasError('required') && materialsForm.get('category')?.touched">
            {{ 'REQUIRED' | translate }}
          </span>
        </label>
        <label class="field">
          <span class="field-label">{{ 'SUBCATEGORY' | translate }}</span>
          <input class="form-control" formControlName="subcategory" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'CODE' | translate }}</span>
          <input class="form-control" formControlName="system_code" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'MANUFACTURER' | translate }}</span>
          <input class="form-control" formControlName="manufacturer_brand" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'BRAND' | translate }}</span>
          <input class="form-control" formControlName="brand" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'MODEL' | translate }}</span>
          <input class="form-control" formControlName="model" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Dimensions and specs</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'UNIT' | translate }}</span>
          <input class="form-control" formControlName="unit" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'SIZE' | translate }}</span>
          <input class="form-control" formControlName="size" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'LENGTH' | translate }}</span>
          <input class="form-control" type="number" formControlName="length" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'WIDTH' | translate }}</span>
          <input class="form-control" type="number" formControlName="width" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'THICKNESS' | translate }}</span>
          <input class="form-control" type="number" formControlName="thickness" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'STRENGTH' | translate }}</span>
          <input class="form-control" formControlName="strength" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'DENSITY' | translate }}</span>
          <input class="form-control" formControlName="density" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'DURABILITY' | translate }}</span>
          <input class="form-control" formControlName="durability" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'FIRE_RESISTANCE' | translate }}</span>
          <input class="form-control" formControlName="fire_resistance" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Stock and cost</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'QUANTITY' | translate }}</span>
          <input class="form-control" type="number" formControlName="quantity" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'UNIT_COST' | translate }}</span>
          <input class="form-control" type="number" formControlName="unit_cost" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'TOTAL_COST' | translate }}</span>
          <input class="form-control" type="number" formControlName="total_cost" readonly />
        </label>
        <label class="field">
          <span class="field-label">{{ 'LOCATION' | translate }}</span>
          <input class="form-control" formControlName="location" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'LEAD_TIME' | translate }}</span>
          <input class="form-control" type="number" formControlName="leadTime" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Usage</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'BUILDING_TYPE' | translate }}</span>
          <input class="form-control" formControlName="building_type" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'USE_CASE' | translate }}</span>
          <input class="form-control" formControlName="use_case" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'CERTIFICATIONS' | translate }}</span>
          <input class="form-control" formControlName="certifications" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'TESTING_METHOD' | translate }}</span>
          <input class="form-control" formControlName="testing_method" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'TOOLS' | translate }}</span>
          <input class="form-control" formControlName="tools" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'METHOD' | translate }}</span>
          <input class="form-control" formControlName="method" />
        </label>
      </div>
    </section>

    <section class="form-section">
      <h2>Geography and ESG</h2>
      <div class="field-grid">
        <label class="field">
          <span class="field-label">{{ 'REGION' | translate }}</span>
          <input class="form-control" formControlName="region" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'REGIONS' | translate }}</span>
          <input class="form-control" formControlName="regions" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'COUNTRIES' | translate }}</span>
          <input class="form-control" formControlName="countries" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'CARBON_FOOTPRINT' | translate }}</span>
          <input class="form-control" type="number" formControlName="carbon_footprint" />
        </label>
        <label class="field">
          <span class="field-label">{{ 'RECYCLABILITY' | translate }}</span>
          <input class="form-control" type="number" formControlName="recyclability" />
        </label>
      </div>
    </section>

    <div class="mat-actions" *ngIf="!viewMode">
      <button type="button" class="ghost-btn" (click)="goBack()">{{ 'CANCEL' | translate }}</button>
      <button type="submit" class="primary-btn" [disabled]="materialsForm.invalid || saving">
        {{ constructionmaterialsId ? ('SAVE' | translate) : ('ADD' | translate) }}
      </button>
    </div>
  </form>
</div>
